/**
 * G-156 — the order of things after a kiosk sale, as a pure rule (OD-34 as
 * refined 2026-09-11; KI-68).
 *
 *   sale → "Print a receipt?" → earnings (only when commission was earned,
 *   with the chime) → the below-floor prompt (the screen's own, after `done`)
 *
 * The receipt comes FIRST because the customer is still at the counter for
 * it and must not be there for the earnings: the amount is the florist's
 * pay, never shown while the tablet may face a customer. The question IS the
 * sale-complete moment, so it closes only on a tap; the 2.5 s timer (OD-18)
 * governs the earnings card alone.
 */

export type SaleCompleteStep =
  | "question"
  | "printing"
  | "failed"
  | "earnings"
  | "done";

/** Commission above zero shows the earnings card and plays the chime. */
export function earnsCommission(commissionEarnedEur: string): boolean {
  const n = Number(commissionEarnedEur);
  return Number.isFinite(n) && n > 0;
}

/** Where the flow starts: the question where a receipt can be offered. */
export function firstStep(
  receiptAvailable: boolean,
  commissionEarnedEur: string,
): SaleCompleteStep {
  return receiptAvailable ? "question" : afterReceipt(commissionEarnedEur);
}

/** Where the flow goes once the receipt step is over — printed, skipped or given up. */
export function afterReceipt(commissionEarnedEur: string): SaleCompleteStep {
  return earnsCommission(commissionEarnedEur) ? "earnings" : "done";
}
